import React from 'react';
import { Box, IconButton, Popover, Tooltip, useTheme } from '@material-ui/core';
import { PostAdd /*  LocalHospitalOutlined, AccountBalance, PlaylistAddCheck  */ } from '@material-ui/icons';
import { alpha, makeStyles } from '@material-ui/core/styles';
import AppsIcon from '@material-ui/icons/Apps';
// import EmailIcon from '@material-ui/icons/Email';
import CmtCard from '../../../../../@coremat/CmtCard';
import CmtCardHeader from '../../../../../@coremat/CmtCard/CmtCardHeader';
import CmtCardContent from '../../../../../@coremat/CmtCard/CmtCardContent';
// import CheckCircleIcon from '@material-ui/icons/CheckCircle';
// import ContactMailIcon from '@material-ui/icons/ContactMail';
// import ChatIcon from '@material-ui/icons/Chat';
import CmtGridView from '../../../../../@coremat/CmtGridView';
import CmtAvatar from '../../../../../@coremat/CmtAvatar';
import { useHistory } from 'react-router-dom';
import clsx from 'clsx';
import Typography from '@material-ui/core/Typography';
import IntlMessages from '../../../../utils/IntlMessages';
import {
  /*   APP_COLOR_FIZCALIZACION_PRIMARY,
  APP_COLOR_FIZCALIZACION_SECONDARY,
  APP_COLOR_MEDIACIONES_PRIMARY,
  APP_COLOR_MEDIACIONES_SECONDARY, */
  APP_COLOR_SEGUIMIENTO_PRIMARY,
  APP_COLOR_SEGUIMIENTO_SECONDARY,
  /*   APP_COLOR_URGENCIA_VITAL_PRIMARY,
  APP_COLOR_URGENCIA_VITAL_SECONDARY, */
} from 'config/config';

const useStyles = makeStyles(theme => ({
  cardRoot: {
    maxWidth: '400px',
    '& .Cmt-header-root': {
      paddingTop: 15,
      paddingBottom: 15,
    },
  },
  typography: {
    padding: theme.spacing(2),
  },
  iconRoot: {
    color: alpha(theme.palette.common.white, 0.38),
    '&:hover, &:focus': {
      color: theme.palette.common.white,
    },
  },
}));

// const actions = [
//   {
//     label: 'More Detail',
//   },
//   {
//     label: 'Close',
//   },
// ];

/* aplicaciones que se mostraran en el menu */
const applications = [
  {
    name: <IntlMessages id={'menu.aplicaciones.analista'} />,
    icon: <PostAdd style={{ color: APP_COLOR_SEGUIMIENTO_PRIMARY, fontSize: 20 }} />,
    bgColor: APP_COLOR_SEGUIMIENTO_SECONDARY,
    path: '/asignaciones',
  },

  /*   {
    name: <IntlMessages id={'menu.aplicaciones.urgenciaVital'} />,
    icon: <LocalHospitalOutlined style={{ color: APP_COLOR_URGENCIA_VITAL_PRIMARY }} />,
    bgColor: APP_COLOR_URGENCIA_VITAL_SECONDARY,
    path: '/urgencia-vital',
  },
  {
    name: <IntlMessages id={'menu.aplicaciones.mediaciones'} />,
    icon: <AccountBalance style={{ color: APP_COLOR_MEDIACIONES_PRIMARY }} />,
    bgColor: APP_COLOR_MEDIACIONES_SECONDARY,
    path: '/mediaciones',
  },
  {
    name: <IntlMessages id={'menu.aplicaciones.fiscalizacion'} />,
    icon: <PlaylistAddCheck style={{ color: APP_COLOR_FIZCALIZACION_PRIMARY }} />,
    bgColor: APP_COLOR_FIZCALIZACION_SECONDARY,
    path: '/fiscalizacion',
  }, */
];

const appItem = (item, index, onClick) => {
  return (
    <Box
      key={index}
      py={2}
      className="pointer"
      display="flex"
      flexDirection="row"
      alignItems="center"
      justifyContent="center"
      onClick={() => onClick(item.path)}>
      <CmtAvatar style={{ backgroundColor: item.bgColor }} size={30}>
        {item.icon}
      </CmtAvatar>
      <Box ml={2} fontSize={12} fontWeight="bold" color="#666666">
        {item.name}
      </Box>
    </Box>
  );
};

const AppsMenu = () => {
  const classes = useStyles();
  const history = useHistory();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const theme = useTheme();

  const onOpenPopOver = event => {
    setAnchorEl(event.currentTarget);
  };

  const onClosePopOver = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const onClickApp = path => {
    history.push(path);
    onClosePopOver();
  };

  return (
    /* menu desplegable de aplicaciones */
    <div>
      <Tooltip title="Aplicaciones">
        <IconButton onClick={onOpenPopOver} className={clsx(classes.iconRoot, 'Cmt-appIcon')}>
          <AppsIcon />
        </IconButton>
      </Tooltip>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={onClosePopOver}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}>
        <CmtCard className={classes.cardRoot}>
          <CmtCardHeader
            title="Aplicaciones"
            actionsPos="top-corner"
            // actions={actions}
            separator={{
              color: theme.palette.borderColor.dark,
              borderWidth: 1,
              borderStyle: 'solid',
            }}
          />
          <CmtCardContent>
            {applications.length > 0 ? (
              <CmtGridView
                itemPadding={24}
                column={1}
                data={applications}
                renderRow={(item, index) => appItem(item, index, onClickApp)}
              />
            ) : (
              <Typography variant="body2">No tiene aplicaciones asignadas.</Typography>
            )}
          </CmtCardContent>
        </CmtCard>
      </Popover>
    </div>
  );
};

export default AppsMenu;
